import { PersonIcon } from "components/Icons/Icons";
import { getNowMinusDays } from "utils/dateUtils";
import { InlineChartRenderer } from "./InlineChartRenderer";

export const NewReferralsLast30Days = () => {
  const beforeMonthFrom = getNowMinusDays(60);

  return (
    <InlineChartRenderer
      chartProps={{
        id: 'new_referrals_last_30_days',
        title: "Новые рефералы",
        icon: <PersonIcon />,
        percentageChangeText: "Изменение за месяц",
        query: {
          "measures": [
            "Referralrecords.count"
          ],
          "filters": [
            {
              "member": "Referralrecords.createdat",
              "operator": "afterDate",
              "values": [
                beforeMonthFrom.toISOString(),
              ]
            }
          ],
          "timeDimensions": [
            {
              "dimension": "Referralrecords.createdat",
              "granularity": "month"
            }
          ]
        },
        pivotConfig: {
          "x": [
            "Referralrecords.createdat.month"
          ],
          "y": [
            "measures"
          ],
          "fillMissingDates": true,
          "joinDateRange": false
        },
        valueProvider: ({resultSet, pivotConfig}) => {
          const length = resultSet.series(pivotConfig)[0]?.series.length ?? 0;
          const currentMonth: number = length < 1 ? 0 : (resultSet.series(pivotConfig)[0]?.series[length - 1]?.value ?? 0);
          const previousMonth: number = length < 2 ? 0 : (resultSet.series(pivotConfig)[0]?.series[length - 2]?.value ?? 0);
          return {
            value: currentMonth,
            previousValue: previousMonth,
            percentageChange: previousMonth === 0 ? (currentMonth === 0 ? 0 : 1) : (currentMonth / previousMonth - 1),
          }
        },
      }}
    />
  );
};